export default "__VITE_ASSET__B8B1KJZE__"